module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Join-3-e9a5fcf1a4cfa46a1e52d85039208ff5.svg";